import { generateUrl } from "@nextcloud/router";
import { checkIfDarkTheme } from "../Functions/isDarkTheme.mjs";
function getAvatarUrl(user, options) {
  var _a;
  const size = ((options == null ? void 0 : options.size) || 64) <= 64 ? 64 : 512;
  const guestUrl = (options == null ? void 0 : options.isGuest) ? "/guest" : "";
  const themeUrl = ((_a = options == null ? void 0 : options.isDarkTheme) != null ? _a : checkIfDarkTheme(document.body)) ? "/dark" : "";
  return generateUrl("/avatar".concat(guestUrl, "/{user}/{size}").concat(themeUrl), {
    user,
    size
  });
}
export {
  getAvatarUrl as g
};
//# sourceMappingURL=getAvatarUrl-C8Q41hfR.mjs.map
